
import React, { Component } from 'react'
import Sidebar from './Sidebar';
import store from '../../../store';
import { connect } from 'react-redux';
import { get_User_District } from '../../../actions/accountAction';
import {
    getOrganizationType, postSkillSearch,
    applyJobSkill, setSkillSearch, setSkillApplied
} from "../../../actions/jobseekerAction";
import Pagination from "react-js-pagination";
import { chunk } from '../../../helpers'
import { Link } from 'react-router'
import ReactHtmlParser from 'react-html-parser';

const RESULT_PER_PAGE = 25

class SearchSkillTraining extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: [],
            jobDetails: false,
            job: [],
            activePage: 1,
            submitted: false
        }
        store.dispatch(get_User_District());
        store.dispatch(getOrganizationType());
    }


    handlePageChange = (activePage) => {
        this.setState({ activePage })
    }

    handleInput = async (e) => {
        const name = e.target.name;
        const value = e.target.value;
        let formData = this.state.formData;
        formData[name] = value;
        if (!value) {
            delete formData[name]
        }
        await this.setState({ formData, submitted: false });
    }

    submit = (e) => {
        e.preventDefault()
        if (Object.keys(this.state.formData).length && !this.state.submitted) {
            this.setState({ activePage: 1 })
            store.dispatch(postSkillSearch(this.state.formData));
            this.setState({ submitted: true })
        }
    }

    createDistoption = () => {
        let Mainprops = this.props;
        let Distoption = []
        if (Mainprops.actionReducer.District.length > 0) {
            Mainprops.actionReducer.District.map(function (data, index) {
                if (data.state_name === 'Punjab') {
                    data.dist.map(function (distdata, distindex) {
                        Distoption.push(<option key={distindex} value={distdata.id}>{distdata.name}</option>)
                        return Distoption
                    })
                }
                return Distoption
            })
        }
        return Distoption
    }

    jobClicked = (job) => {
        this.setState({ job, jobDetails: true })
    }

    submitSkill = async () => {
        if (this.state.job) {
            await store.dispatch(applyJobSkill(this.state.job.id))
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.JobseekerReducer.skillApplied) {
            this.props.router.push('myaccount')
        }
    }

    componentWillUnmount() {
        store.dispatch(setSkillSearch([]))
        store.dispatch(setSkillApplied(false))
    }

    getCourseNature = (id) => {
        const name = this.props.JobseekerReducer.organisations &&
            this.props.JobseekerReducer.organisations.filter((cor) => cor.id === id)
        return name[0].name
    }

    render() {
        if (localStorage.getItem('Islogin') !== 'true') {
            this.props.router.push('/');
        }
        const Mainprops = this.props
        const { jobDetails, job, formData, activePage } = this.state

        let searchResults = chunk(Mainprops.JobseekerReducer.skillResults, RESULT_PER_PAGE)
        return (
            <section className="back-dashboard widget-sidebar-context mt-3" id="my-sidebar-context">
                <div className="container">
                    <div className="row">
                        <a aria-label='Toggle Sidebar' href="/#" className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </a>
                        <Sidebar route={Mainprops.route} />
                        <main className="col col-md-9 second-side ps-4 pb-3 h-100">

                            <div className="clearfix"></div>
                            {/* <!-- Tab panes --> */}
                            {jobDetails && job && <div className="tab-content">
                                <div id="home" className=" tab-pane active">
                                    <section className="login-form mt-0">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-md-12  mx-auto   p-0">
                                                    <div className="panel-heading">
                                                        <h6 className="mb-0">Apply Skill</h6>
                                                    </div>
                                                    <div className="panel-body">


                                                        <div className="row ">
                                                            <div className="col-md-12">
                                                                <div className="cover-shadow p-3 m-2 spacebx4">
                                                                    <div className="row">
                                                                        <div className="col-lg-3 col-sm-6 col-6 ">
                                                                            <p className={"bold"}>Course: </p>
                                                                        </div>
                                                                        <div className="col-lg-9 col-sm-6 col-6">
                                                                            <label>{job.course_name ? job.course_name : 'None'}</label>
                                                                        </div>
                                                                    </div>


                                                                    <div className="row">
                                                                        <div className="col-lg-3 col-sm-6 col-6 ">
                                                                            <p className={"bold"}>Duration (In days) :</p>
                                                                        </div>
                                                                        <div className="col-lg-9 col-sm-6 col-6">
                                                                            <label>
                                                                                {job.course_duration}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-lg-3 col-sm-6 col-6 ">
                                                                            <p className={"bold"}>Course type :</p>
                                                                        </div>
                                                                        <div className="col-lg-9 col-sm-6 col-6">
                                                                            <label>
                                                                                {this.getCourseNature(job.course_nature)}
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row">
                                                                        <div className="col-lg-3 col-sm-6  ">
                                                                            <p>Course description :</p>
                                                                        </div>
                                                                        <div className="col-lg-9 col-sm-6 ">
                                                                            <label>{job.course_description ? ReactHtmlParser(job.course_description) : ''}</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row">
                                                                        <div className="col-lg-3 col-sm-6  ">
                                                                            <p>Location :</p>
                                                                        </div>
                                                                        <div className="col-lg-9 col-sm-6 ">
                                                                            <label>{job.location_name ? job.location_name : ''}</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row">
                                                                        <div className="col-lg-3 col-sm-6  ">
                                                                            <p>Course fees :</p>
                                                                        </div>
                                                                        <div className="col-lg-9 col-sm-6 ">
                                                                            <label>{job.course_fees ? job.course_fees : ''}</label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="row mt-3" >
                                                                        <div className="col-md-12">
                                                                            <hr />
                                                                            <button
                                                                                aria-label='Apply for this course'
                                                                                type='button'
                                                                                onClick={this.submitSkill} className="btn btn-primary btn-primary2 mt-1">Apply</button>
                                                                            <button
                                                                                aria-label='Cancel and go back to search results'
                                                                                type='button'
                                                                                onClick={() => this.setState({ jobDetails: false })} style={{ "marginLeft": "10px" }} className="btn btn-primary btn-primary2 mt-1">Cancel</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>}


                            {!jobDetails && <div>
                                <div className="tab-content">
                                    <div id="home" className=" tab-pane active">
                                        <section className="login-form mt-0">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-sm-12 col-lg-12  mx-auto   p-0">
                                                        <div className="panel-heading">
                                                            <h6 className="mb-0">Search Skill Training/Soft Skill Training</h6>
                                                        </div>


                                                        <div className="panel-body mt-2">
                                                            <form onSubmit={this.submit}>
                                                                <div className="form-group">
                                                                    <div className="row">
                                                                        <div className="col-sm-4 col-md-2 col-5">
                                                                            <label>Skill Training for</label>
                                                                        </div>

                                                                        <div className="col-sm-8 col-md-7  col-7">
                                                                            <select onChange={this.handleInput}
                                                                                className="form-control" id="sel1"
                                                                                value={formData.course_nature ? formData.course_nature : ''}
                                                                                name="course_nature" aria-label="Select Course Nature">
                                                                                <option value="">Select</option>
                                                                                {Mainprops.JobseekerReducer.organisations.length > 0 &&
                                                                                    Mainprops.JobseekerReducer.organisations.map(function (data, index) {
                                                                                        return (
                                                                                            <option key={index} value={data.id}>{data.name}</option>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="form-group">
                                                                    <div className="row">
                                                                        <div className="col-sm-4 col-md-2 col-5">
                                                                            <label>Location </label>
                                                                        </div>

                                                                        <div className="col-sm-8 col-md-7  col-7">
                                                                            <select name="location" className="form-control" aria-label="Select District"
                                                                                value={formData.location ? formData.location : ''}
                                                                                onChange={this.handleInput}>
                                                                                <option value="">Select District</option>
                                                                                {this.createDistoption()}
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <hr />
                                                                <div className="form-group">
                                                                    <div className="row">
                                                                        <div className="offset-sm-4 offset-md-2 col-md-2  col-sm-8 col-7">
                                                                            <button
                                                                                aria-label='Submit Skill Training Search Form'
                                                                                type="submit" className="btn btn-primary btn-primary2 mt-1">Search</button>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>
                                {formData && Mainprops.JobseekerReducer.skillResults && Mainprops.JobseekerReducer.skillResults.length > 0 &&
                                    <div className="tab-content">
                                        <div id="home" className=" tab-pane active">
                                            <section className="login-form mt-0">
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="col-md-12  mx-auto   p-0">
                                                            <div className="panel-heading">
                                                                <h6 className="mb-0">Results</h6>
                                                            </div>
                                                            {/* <div className="panel-body"> */}
                                                            {/* <form> */}
                                                            <div className="panel-body">
                                                                {searchResults && searchResults.length && searchResults[activePage - 1].map((job, key) => {
                                                                    return (
                                                                        <div className="job-sec bg-white cover-shadow mb-2 p-3" key={key} onClick={() => this.jobClicked(job)} style={{ "cursor": "pointer" }}>
                                                                            <Link >{job.course_name ? job.course_name : ''}</Link>
                                                                            <div className="row">
                                                                                <div className="col-md-8">
                                                                                    <ul className="nav">
                                                                                        {/* <li className="list-items-inline"><i className="fa fa-briefcase  pr-2"></i>{job.org_name ? job.org_name: 'None'}</li> */}
                                                                                        <li className="list-items-inline pt-2 pl-3" title={'Course location'}><i className="fa fa-map-marker  pr-2"></i> {job.location_name ? job.location_name : ''}</li>
                                                                                        <li className="list-items-inline pt-2 pl-3" title={'Course fees'}><i className="fa fa-rupee pr-2" aria-hidden="true"></i>{" " + job.course_fees}</li>
                                                                                        <li className="list-items-inline pt-2 pl-3" title={'Course duration(In days)'}><i className="fa fa-clock-o" aria-hidden="true"></i>{" " + job.course_duration}
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    )
                                                                })}

                                                                {searchResults && searchResults.length > 1 ? <div className='react-pagination'>
                                                                    <Pagination
                                                                        pageRangeDisplayed={10}
                                                                        activePage={activePage}
                                                                        itemsCountPerPage={RESULT_PER_PAGE}
                                                                        totalItemsCount={Mainprops.JobseekerReducer.skillResults.length}
                                                                        onChange={this.handlePageChange}
                                                                    />
                                                                </div> : ''}

                                                            </div>
                                                            <hr />
                                                            {/* </form> */}
                                                            {/* </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>}

                                {Mainprops.JobseekerReducer.skillResults && Mainprops.JobseekerReducer.skillResults.status === '401' && <div className="tab-content">
                                    <div id="home" className=" tab-pane active">
                                        <section className="login-form mt-0">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-md-12  mx-auto   p-0">
                                                        <div className="panel-heading">
                                                            <h6 className="mb-0">Results</h6>
                                                        </div>
                                                        <div className="panel-body">
                                                            <h3>{Mainprops.JobseekerReducer.skillResults.message}</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </div>}

                            </div>
                            }

                        </main>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = store => {
    return store;
};

export default connect(mapStateToProps)(SearchSkillTraining);
